.base,
.base *,
.base *::before,
.base *::after {
  box-sizing: border-box;
}

.base {
  display: block;
  width: var(--skeleton-width, 100%);
  height: var(--skeleton-height, 1rem);

  background-color: var(--bg-inset);
  background-image: linear-gradient(
    90deg,
    var(--bg-inset) 0%,
    var(--bg-inset) 20%,
    var(--bg-hover) 50%,
    var(--bg-inset) 80%,
    var(--bg-inset) 100%
  );
  background-size: 1200px 100%;

  animation: shimmer 2s ease-in-out infinite;
}

@keyframes shimmer {
  from {
    background-position: -600px 0;
  }
  to {
    background-position: 600px 0;
  }
}

.static {
  background-image: none;
  animation: none;
}

/* ── Shapes ── */

.rect {
  border-radius: var(--radius-md);
}

.text {
  height: var(--skeleton-height, 1em);
  border-radius: var(--radius-sm);
}

/* Width mirrors height rather than relying on aspect-ratio: `width: auto` on a
   block element means "fill the container", so the circle came out an ellipse
   everywhere except inside a flex parent. */
.circle {
  width: var(--skeleton-width, var(--skeleton-height, 2.5rem));
  height: var(--skeleton-height, 2.5rem);
  border-radius: var(--radius-round);
}

/* A stack of text lines reads as a paragraph, not one solid block. */
.text + .text {
  margin-top: var(--space-2);
}

/* The shimmer is decoration; the placeholder still communicates without it. */
@media (prefers-reduced-motion: reduce) {
  .base {
    background-image: none;
    animation: none;
  }
}
